import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatDate } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { MagnifyingGlass } from "@phosphor-icons/react";

export default function CommunicationsPage() {
  const [comms, setComms] = useState([]);
  const [matters, setMatters] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    (async () => {
      const [c, m] = await Promise.all([api.get("/communications"), api.get("/matters")]);
      setComms(c.data); setMatters(m.data);
    })();
  }, []);

  const matterMap = useMemo(() => Object.fromEntries(matters.map((m) => [m.id, m])), [matters]);
  const filtered = comms.filter((c) => {
    const s = q.toLowerCase();
    return !s || [c.subject, c.summary, c.participants, matterMap[c.matter_id]?.title].some((v) => (v || "").toLowerCase().includes(s));
  });

  return (
    <div className="space-y-6">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div>
          <div className="text-[10px] tracking-[0.25em] uppercase text-slate-500 mb-1">Correspondence</div>
          <h2 className="font-serif-brand text-3xl">Communications Log</h2>
        </div>
        <div className="relative">
          <MagnifyingGlass size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <Input placeholder="Search log…" value={q} onChange={(e) => setQ(e.target.value)} className="pl-8 rounded-sm h-9 w-72 border-slate-300" />
        </div>
      </div>

      <div className="space-y-2">
        {filtered.length === 0 && <div className="border border-slate-200 bg-white rounded-sm p-10 text-center text-sm text-slate-500">No entries.</div>}
        {filtered.map((c) => (
          <div key={c.id} className="border border-slate-200 bg-white rounded-sm p-5 flex gap-5">
            <div className="w-24 shrink-0">
              <div className="text-[10px] uppercase tracking-wider text-slate-500">{c.comm_type}</div>
              <div className="text-xs text-slate-500 mt-1">{formatDate(c.occurred_at)}</div>
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-medium">{c.subject}</div>
              {matterMap[c.matter_id] && (
                <Link to={`/matters/${c.matter_id}`} className="text-xs text-slate-500 hover:underline">
                  <span className="font-mono-num">{matterMap[c.matter_id].reference}</span> · {matterMap[c.matter_id].title}
                </Link>
              )}
              {c.participants && <div className="text-xs text-slate-500 mt-1">With: {c.participants}</div>}
              {c.summary && <div className="text-sm text-slate-600 mt-2 whitespace-pre-wrap">{c.summary}</div>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
